var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClassreviewStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2997_85901)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9374 9.20695C23.7803 8.72097 23.3493 8.37581 22.8393 8.32985L15.9123 7.70087L13.1731 1.28963C12.9712 0.819771 12.5112 0.515625 12.0001 0.515625C11.4891 0.515625 11.0291 0.819771 10.8271 1.29073L8.08797 7.70087L1.15982 8.32985C0.65077 8.37691 0.220828 8.72097 0.0628038 9.20695C-0.0952203 9.69292 0.0507185 10.226 0.435799 10.562L5.67183 15.154L4.12785 21.9553C4.01487 22.4553 4.20897 22.9723 4.62389 23.2722C4.84692 23.4333 5.10785 23.5154 5.37098 23.5154C5.59786 23.5154 5.8229 23.4542 6.02487 23.3333L12.0001 19.7621L17.9732 23.3333C18.4103 23.5963 18.9612 23.5723 19.3752 23.2722C19.7904 22.9713 19.9843 22.4542 19.8713 21.9553L18.3273 15.154L23.5633 10.5629C23.9484 10.226 24.0955 9.69384 23.9374 9.20695Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2997_85901"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassreviewStar);
export default __webpack_public_path__ + "static/media/classreview-star.694b6c6aa904469872179d572fc79507.svg";
export { ForwardRef as ReactComponent };